<template>
  <PersonalAreaTemplate max-width="800">
    <v-form class="d-grid gap-8" ref="form" lazy-validation>
      <GoogleAutocomplete
        :title="
          localStorage.translations.pages['setting-personal_area'].sections[
            'adres-prozhivaniya-v-finlyandii'
          ]
        "
        :street="addressData.street"
        :zip="addressData.zip"
        :city="addressData.city"
        :on-change="changeAddress"
        :readonly="!editing"
      />
      <div v-for="(i, index) in additionalAddress" :key="index">
        <GoogleAutocomplete
          :title="i.name"
          :street="i.street"
          :zip="i.zip"
          :city="i.city"
          :id="index"
          :on-change="changeAdditionalAddress"
          :readonly="!editing"
        />
      </div>
    </v-form>
    <ContactAdressAddModal
      v-if="editing && additionalAddress.length <= 3"
      @addAddress="addAddress"
    />
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'

import ContactAdressAddModal from 'components/personalArea/ContactAdressAddModal'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'
import GoogleAutocomplete from 'components/google/autocomplete/GoogleAutocomplete'
export default {
  name: 'ContactAddress',
  props: {
    editing: Boolean,
    address: Object,
    additional_address: Object,
    userId: Number,
    employeeId: Number,
  },

  components: { GoogleAutocomplete, PersonalAreaTemplate, ContactAdressAddModal },
  data: () => ({
    addressData: {
      street: null,
      city: null,
      zip: null,
    },
    additionalAddress: [],
    test: false,
  }),
  mounted() {
    this.onActualAddressData()
    this.onActualAdditionalAddress()
  },
  watch: {
    address() {
      this.onActualAddressData()
    },
    additional_address() {
      this.onActualAdditionalAddress()
    },
    addressData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { addressData: this.addressData },
            overwrite: false,
          })
        }
      },
    },
    additionalAddress: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { additionalAddress: this.additionalAddress },
            overwrite: false,
          })
        }
      },
    },
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onActualAddressData() {
      this.addressData.street = this.address.street
      this.addressData.city = this.address.city
      this.addressData.zip = this.address.zip
      this.onNavigationGuardianCheck({
        data: { addressData: this.addressData },
        overwrite: true,
      })
    },
    onActualAdditionalAddress() {
      if (this.additional_address) {
        this.additionalAddress = JSON.parse(this.additional_address.data)
      }
      this.onNavigationGuardianCheck({
        data: { additionalAddress: this.additionalAddress },
        overwrite: true,
      })
    },
    addAddress(data) {
      this.additionalAddress.push(data)
    },
    saveChange() {
      return new Promise(async (resolve, reject) => {
        let resolveData = {
          address: true,
          additionalAddress: true,
        }
        if (this.$checkNavigationGuardianChange('addressData')) {
          let data = {
            street: this.addressData.street,
            city: this.addressData.city,
            zip: this.addressData.zip,
          }
          resolveData.address = data
        }
        if (this.$checkNavigationGuardianChange('additionalAddress')) {
          let additionalData = {
            type: 'additional_address',
            data: JSON.stringify(this.additionalAddress),
          }
          if (!this.additional_address || this.additional_address.data === null) {
            if (this.$route.name === 'PersonalAreaEmployeeEdit') {
              additionalData.user_id = this.userId
            }
          } else {
            additionalData.id = this.additional_address.id
          }
          resolveData.additionalAddress = additionalData
        }
        resolve(resolveData)
      })
    },
    changeAddress(data) {
      this.addressData.street = data.street
      this.addressData.zip = data.zip
      this.addressData.city = data.city
    },
    changeAdditionalAddress(data) {
      this.additionalAddress[data.id].street = data.street
      this.additionalAddress[data.id].zip = data.zip
      this.additionalAddress[data.id].city = data.city
    },
  },
}
</script>
